import { all } from "redux-saga/effects";
import { sagas as routeSagas } from "./rotas.saga";
import { sagas as authSagas } from "./autenticacao.saga";
import { sagas as propostasSagas } from "./propostas.saga";
import { sagas as cargaConsultasSagas } from "./administracao/cargaConsultas.saga";
import { sagas as documentosSaga } from "./documentos.saga";
import { sagas as imovelSaga } from "./imovel.saga";
import { sagas as dominiosSagas } from "./dominios.saga";
import { sagas as usuariosSagas } from "./administracao/usuarios.saga";
import { sagas as exportConsultasSagas } from "./administracao/exportConsultas.saga";
import { sagas as matrizChecklistSagas } from "./administracao/matrizChecklist.saga";
import { sagas as documentosSagas } from "./administracao/documentos.saga";
import { sagas as relatorioBISagas } from "./administracao/relatorioBI.saga";
import { sagas as atividadesSagas } from "./administracao/atividades.saga";
import { sagas as etapasSagas } from "./administracao/etapas.saga";
import { sagas as produtosSagas } from "./administracao/produtos.saga";
import { sagas as perfisSagas } from "./administracao/perfis.saga";
import { sagas as organizacaoSagas } from "./administracao/organizacao.saga";
import { sagas as dashboardSagas } from "./dashboard.saga";
import { sagas as exportSla } from "./administracao/exportSla.saga";
import { sagas as localidadesSagas } from "./administracao/localidades.saga";
import { sagas as motivoCancelamentoSagas } from "./administracao/motivoCancelamento.saga";
import { sagas as tiposDeConvenios } from "./administracao/tiposDeConvenios.saga";
import { sagas as produtosConvenio } from "./administracao/produtosConvenio.saga";
import { sagas as templatesEmailSagas } from "./administracao/templatesEmail.saga";
import { sagas as emailSagas } from "./emails.saga";
import { sagas as relatoriosSagas } from "./administracao/relatorios.saga";

function* sagas() {
  yield all([
    ...authSagas,
    ...propostasSagas,
    ...cargaConsultasSagas,
    ...documentosSaga,
    ...routeSagas,
    ...imovelSaga,
    ...dominiosSagas,
    ...usuariosSagas,
    ...exportConsultasSagas,
    ...documentosSagas,
    ...atividadesSagas,
    ...etapasSagas,
    ...matrizChecklistSagas,
    ...produtosSagas,
    ...perfisSagas,
    ...organizacaoSagas,
    ...dashboardSagas,
    ...exportSla,
    ...localidadesSagas,
    ...motivoCancelamentoSagas,
    ...tiposDeConvenios,
    ...relatorioBISagas,
    ...produtosConvenio,
    ...templatesEmailSagas,
    ...emailSagas,
    ...relatoriosSagas,
  ]);
}

export default sagas;
